@if (controlCenter$ | async; as controlCenter) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: controlCenter, frm: mainFrm }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: controlCenter, frm: mainFrm }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <form #mainFrm="ngForm" class="flex layout-col">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="terminalDetailTab">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}">
          <elder-single-pane-wrapper>
            <elder-pane-header>
              <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
            </elder-pane-header>
            <elder-pane-content>
              <div class="flex layout-row gap-xl">
                <!-- Identification -->
                <div class="flex layout-col">
                  <h4 elderpaneSubtitle>{{ 'context.identification' | translate }}</h4>
                  <div class="layout-row gap-md">
                    <mat-form-field>
                      <mat-label>{{ 'context.facility' | translate }}</mat-label>
                      <elder-select
                        appFacilitySelect
                        name="facility"
                        class="flex"
                        placeholder="{{ 'facilities.facility' | translate }}"
                        required
                        [disabled]="!creationMode"
                        valueAsId
                        [(ngModel)]="controlCenter.facility"
                      >
                      </elder-select>
                    </mat-form-field>
                    <mat-form-field class="flex">
                      <mat-label>{{ 'context.number' | translate }}</mat-label>
                      <input
                        matInput
                        name="number"
                        required
                        placeholder="{{ 'context.number' | translate }}"
                        [(ngModel)]="controlCenter.number"
                        #numberModel="ngModel"
                      />
                      <mat-error elderValidationError></mat-error>
                    </mat-form-field>
                  </div>
                  <div class="layout-row gap-md">
                    <mat-form-field>
                      <mat-label>{{ 'context.type' | translate }}</mat-label>
                      <elder-select
                        appControlCenterTypeSelect
                        name="type"
                        class="flex"
                        required
                        [disabled]="!creationMode"
                        valueAsId
                        [(ngModel)]="controlCenter.type"
                      >
                      </elder-select>
                    </mat-form-field>
                    <mat-form-field class="flex">
                      <mat-label>{{ 'context.name' | translate }}</mat-label>
                      <input
                        matInput
                        name="name"
                        placeholder="{{ 'context.name' | translate }}"
                        [(ngModel)]="controlCenter.name"
                      />
                    </mat-form-field>
                  </div>
                  <div class="layout-row gap-md">
                    <mat-form-field class="flex">
                      <mat-label>{{ 'context.description' | translate }}</mat-label>
                      <input
                        matInput
                        name="description"
                        placeholder="{{ 'context.description' | translate }}"
                        [(ngModel)]="controlCenter.description"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="flex layout-col">
                  <!-- Printer -->
                  <h4 elderpaneSubtitle>{{ 'printers.title' | translate }}</h4>
                  <!-- Label Printer -->
                  <mat-form-field>
                    @if (controlCenter) {
                      <mat-hint>{{ controlCenter?.labelPrinter?.printerId }}</mat-hint>
                    }
                    <mat-label>{{ 'printers.labelPrinter' | translate }}</mat-label>
                    <elder-select
                      appPrinterSelect
                      allowNull
                      [filterFacility]="controlCenter.facility"
                      valueAsId
                      [(value)]="controlCenter.labelPrinter.printerId"
                    >
                      <div *elderSelectValue="let printer" class="layout-col">
                        <span style="line-height: 20px">{{ printer.description }}</span>
                        <span class="mat-caption">{{ printer.id }}</span>
                      </div>
                    </elder-select>
                  </mat-form-field>
                  <!-- Document Printer -->
                  <mat-form-field>
                    @if (controlCenter) {
                      <mat-hint>{{ controlCenter?.documentPrinter?.printerId }}</mat-hint>
                    }
                    <mat-label>{{ 'printers.documentPrinter' | translate }}</mat-label>
                    <elder-select
                      appPrinterSelect
                      allowNull
                      [filterFacility]="controlCenter.facility"
                      valueAsId
                      [(value)]="controlCenter.documentPrinter.printerId"
                    >
                      <div *elderSelectValue="let printer" class="layout-col">
                        <span style="line-height: 20px">{{ printer.description }}</span>
                        <span class="mat-caption">{{ printer.id }}</span>
                      </div>
                    </elder-select>
                  </mat-form-field>
                </div>
              </div>
            </elder-pane-content>
          </elder-single-pane-wrapper>
        </mat-tab>
        @switch (controlCenter.type) {
          @case (ControlCenterType.WORK_STATION) {
            <!-- pane/pane -->
            <mat-tab label="{{ 'shopfloor.workstations.title' | translate }}">
              <elder-single-pane-wrapper>
                <elder-pane-header>
                  <elder-pane-title>{{
                    'shopfloor.workstations.title' | translate
                  }}</elder-pane-title>
                </elder-pane-header>
                <elder-pane-content>
                  <app-work-station-table
                    class="flex"
                    [(workStationIds)]="controlCenter.workStations"
                    [facilityId]="controlCenter.facility"
                  >
                  </app-work-station-table>
                </elder-pane-content>
              </elder-single-pane-wrapper>
            </mat-tab>
          }
          @case (ControlCenterType.STORAGE) {
            <mat-tab label="{{ 'Storage' | translate }}">
              <elder-single-pane-wrapper>
                <elder-pane-header>
                  <elder-pane-title>{{ 'Storage Detail' | translate }}</elder-pane-title>
                </elder-pane-header>
                <elder-pane-content>
                  <div>
                    <mat-form-field>
                      <input
                        matInput
                        name="storageScope"
                        required
                        placeholder="{{ 'Storage Scope' | translate }}"
                        [(ngModel)]="controlCenter.storage.storageScope"
                      />
                    </mat-form-field>
                  </div>
                </elder-pane-content>
              </elder-single-pane-wrapper>
            </mat-tab>
          }
        }
      </mat-tab-group>
    </form>
  </div>
}

<ng-template #header let-controlCenter let-frm="frm">
  @if (creationMode) {
    <span>
      {{ 'shopfloor.controlcenters.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="controlCenter.name" [subheader]="'ID: ' + controlCenter.id">
    </elder-header>
  }

  <span class="flex"></span>

  <button mat-icon-button [disabled]="creationMode" (click)="openTerminalDialog($event)">
    <mat-icon>open_in_browser</mat-icon>
  </button>

  <button mat-icon-button [disabled]="!frm.form.valid" (click)="onSave($event)">
    <mat-icon>save</mat-icon>
  </button>

  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
      <mat-icon>delete</mat-icon>
      <span>{{ 'actions.delete' | translate }}</span>
    </button>
  </mat-menu>
</ng-template>
